import { render, staticRenderFns } from "./ClaimCustomer.vue?vue&type=template&id=3207f9a8"
import script from "./ClaimCustomer.vue?vue&type=script&lang=js"
export * from "./ClaimCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports